import { gql } from '@apollo/client'

import { ClusterDocResultsFragments } from './fragments'

export const FETCH_MORE_ITEMS = gql`
  query thesisClusterMoreItems($filters: [FilterInput], $limit: Int, $offset: Int) {
    root {
      searchHaystack(
        query: ""
        kinds: [JURISPRUDENCE]
        limit: $limit
        offset: $offset
        filters: $filters
      ) {
        items {
          ...ClusterDocResults_haystackItem
        }
      }
    }
  }
  ${ClusterDocResultsFragments.haystackItem}
`
